import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Map from "../components/Map";
import { displayDate } from "../utils/utils";
import { serverURL } from "./networking";

export default function ReportList() {
    // Get List of Reports from Server
    const [reports, setReports] = useState([]);
    const [plotCoordinates, setPlotCoordinates] = useState([]);
    const navigate = useNavigate();

    let csrf = document.cookie.replace(
        /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
        "$1",
    );

    useEffect(() => {
        axios
            .get(serverURL + "/api/plot/", {
                withCredentials: true,
                headers: {
                    "X-CSRFToken": csrf,
                },
            })
            .then(function (response) {
                const plots = response.data.plots;
                setReports(sortPlots(plots));
                setPlotCoordinates(
                    plots.map((plot) => ({
                        lon: plot["center_longitude"],
                        lat: plot["center_latitude"],
                    })),
                );
            })
            .catch(function (error) {
                console.log(error.response);
                navigate("/");
            });
    }, []);

    function DeletePlot(plot_id) {
        let csrf = document.cookie.replace(
            /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
            "$1",
        );
        axios
            .post(
                serverURL + "/api/plot/delete/",
                { plot_id: plot_id, user_id: sessionStorage.user_id },
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                },
            )
            .then(function (response) {
                console.log(response);
                window.location.reload();
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    function ShowPopUp(plot_id) {
        if (
            window.confirm(
                "Are you sure you want to delete this plot? This action cannot be undone.",
            )
        ) {
            DeletePlot(plot_id);
        }
    }

    /// For checking how the user wants their plots ordered and sorting the plots
    /// appropriately. If the user has not made a selection, "Sort by newest"
    /// is selected for them.
    function sortPlots(plots) {
        const sort = localStorage.getItem("sort");
        if (sort === null) {
            localStorage.setItem("sort", "NEW");
        }
        document.getElementById(sort).checked = true;
        if (sort === "NEW") {
            return plots.sort(
                (a, b) =>
                    Date.parse(b.date_collected) - Date.parse(a.date_collected),
            );
        } else if (sort === "OLD") {
            return plots.sort(
                (a, b) =>
                    Date.parse(a.date_collected) - Date.parse(b.date_collected),
            );
        } else if (sort === "ALPH") {
            return plots.sort((a, b) =>
                String(a.name).localeCompare(String(b.name)),
            );
        } else {
            throw new Error("Sorting method not implemented.");
        }
    }

    return (
        <div>
            <h1 className="section-title">Plot Data</h1>

            <input
                type="radio"
                id="NEW"
                name="sort"
                value="NEW"
                onClick={() => {
                    localStorage.setItem("sort", "NEW");
                    window.location.reload();
                }}
            ></input>
            <label htmlFor="NEW">Sort by Newest </label>
            <input
                type="radio"
                id="OLD"
                name="sort"
                value="OLD"
                onClick={() => {
                    localStorage.setItem("sort", "OLD");
                    window.location.reload();
                }}
            ></input>
            <label htmlFor="OLD">Sort by Oldest </label>
            <input
                type="radio"
                id="ALPH"
                name="sort"
                value="ALPH"
                onClick={() => {
                    localStorage.setItem("sort", "ALPH");
                    window.location.reload();
                }}
            ></input>
            <label htmlFor="ALPH">Sort by Name</label>
            {/* 
            TODO: Uncomment once Figma design is finalized
            <Map plotCoordinates={plotCoordinates} /> */}
            <ul>
                {reports.length < 1 ? (
                    <p>
                        No reports found in account! Try uploading some forest
                        plot data!
                    </p>
                ) : (
                    reports.map((report) => (
                        <li key={report.plot_id} className="report-list-option">
                            <div
                                onClick={() =>
                                    navigate(
                                        "/home/reports?report=" +
                                            report.name +
                                            "&plotId=" +
                                            report.plot_id,
                                    )
                                }
                                className="plot-main-info"
                            >
                                <h4>
                                    Report:{" "}
                                    {report.file_status &&
                                    report.file_status === "draft"
                                        ? "(DRAFT) " + report.name
                                        : report.name}
                                </h4>
                                <p>
                                    Collected at{" "}
                                    {report.center_latitude.toFixed(6)}°,{" "}
                                    {report.center_longitude.toFixed(6)}°
                                </p>
                                <p>
                                    Collected on:{" "}
                                    {displayDate(report.date_collected)}
                                </p>
                            </div>
                            <div
                                onClick={() =>
                                    navigate(
                                        "/home/reports?report=" +
                                            report.name +
                                            "&plot_id=" +
                                            report.plot_id +
                                            "/",
                                    )
                                }
                                className="plot-notes"
                            >
                                <p>{report.notes}</p>
                            </div>
                            <div>
                                <button
                                    className="button"
                                    onClick={() => ShowPopUp(report.plot_id)}
                                >
                                    Delete
                                </button>
                            </div>
                        </li>
                    ))
                )}
            </ul>
        </div>
    );
}
